import { Box, Drawer, IconButton, Stack, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { TOURNAMENT_TERMS, type TournamentTermKey } from "@bw/shared/tournaments";

/**
 * Every standard tournament term in player wording (#2691, F25), as a bottom
 * sheet. Opened from a term's "All terms" link; the term that opened it is
 * shown first.
 */
export function TournamentTermsSheet({
  open,
  onClose,
  focusTerm,
}: {
  open: boolean;
  onClose: () => void;
  focusTerm?: TournamentTermKey;
}) {
  const terms = focusTerm
    ? [...TOURNAMENT_TERMS].sort((a, b) => Number(b.key === focusTerm) - Number(a.key === focusTerm))
    : TOURNAMENT_TERMS;
  return (
    <Drawer
      anchor="bottom"
      onClose={onClose}
      open={open}
      slotProps={{ paper: { sx: { borderTopLeftRadius: 16, borderTopRightRadius: 16, maxHeight: "80vh" } } }}
    >
      <Box aria-labelledby="tournament-terms-title" component="section" role="dialog" sx={{ p: 2, pb: 3 }}>
        <Stack direction="row" sx={{ alignItems: "center", mb: 1 }}>
          <Typography component="h2" id="tournament-terms-title" sx={{ fontWeight: 700, fontSize: "1.0625rem", flex: 1 }}>
            Tournament terms
          </Typography>
          <IconButton aria-label="Close tournament terms" onClick={onClose} size="small">
            <CloseIcon fontSize="small" />
          </IconButton>
        </Stack>
        <Box component="dl" sx={{ m: 0 }}>
          {terms.map((term) => (
            <Box key={term.key} sx={{ py: 1.25, borderTop: 1, borderColor: "divider" }}>
              <Typography component="dt" sx={{ fontWeight: 700, fontSize: "0.9375rem" }}>
                {term.label}
              </Typography>
              <Typography color="text.secondary" component="dd" sx={{ m: 0, mt: 0.25, fontSize: "0.875rem" }}>
                {term.player}
              </Typography>
            </Box>
          ))}
        </Box>
      </Box>
    </Drawer>
  );
}
